// Helpers y estilos compartidos por las sub-páginas de Presea (Cola,
// Resolución, Maestros). Extraído de PreseaPage.jsx al dividir 24/06/26.

export function estadoPillStyle(estado) {
  switch (estado) {
    case 'procesado':       return { background: '#dcfce7', color: '#166534' }
    case 'pendiente':
    case 'pendiente_envio': return { background: '#fef3c7', color: '#92400e' }
    case 'error':           return { background: '#fee2e2', color: '#991b1b' }
    default:                return { background: '#f1f5f9', color: '#475569' }
  }
}

export function syncPillStyle(estado) {
  switch (estado) {
    case 'procesado':   return { background: '#dcfce7', color: '#166534' }
    case 'sin_cambios': return { background: '#f1f5f9', color: '#475569' }
    case 'error':       return { background: '#fee2e2', color: '#991b1b' }
    default:            return { background: '#f1f5f9', color: '#475569' }
  }
}

// Resumen legible de los contadores del import (claves variables por tipo)
export function resumirSync(r) {
  const partes = []
  if (r.total != null) partes.push(`${r.total} en archivo`)
  if (r.articulos_total != null) partes.push(`${r.articulos_total} artículos`)
  if (r.nuevos) partes.push(`${r.nuevos} nuevos`)
  if (r.articulos_nuevos) partes.push(`${r.articulos_nuevos} nuevos`)
  if (r.actualizados) partes.push(`${r.actualizados} actualizados`)
  if (r.articulos_actualizados) partes.push(`${r.articulos_actualizados} actualizados`)
  if (r.codigos_completados) partes.push(`${r.codigos_completados} códigos Presea completados`)
  if (r.conflictos_sku) partes.push(`⚠ ${r.conflictos_sku} conflictos SKU`)
  if (r.precios) partes.push(`${r.precios} precios (${(r.listas || []).join(', ')})`)
  return partes.join(' · ') || '—'
}

export function fmtFecha(s) {
  if (!s) return '—'
  const d = new Date(s)
  return d.toLocaleString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
}

// Estilos compartidos
export const st = {
  title:      { margin: '0 0 0.25rem', fontSize: '1.4rem', fontWeight: 700, color: '#1e293b' },
  sub:        { margin: '0 0 1.5rem', color: '#64748b', fontSize: '0.9rem', lineHeight: 1.5 },
  card:       { background: 'white', borderRadius: 10, boxShadow: '0 1px 4px rgba(0,0,0,0.07)', padding: '1.25rem', marginBottom: '1rem' },
  cardHead:   { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem', marginBottom: '0.75rem', flexWrap: 'wrap' },
  cardTitle:  { margin: 0, fontSize: '1rem', fontWeight: 700, color: '#1e293b' },
  muted:      { color: '#94a3b8', fontSize: '0.85rem', margin: '0.25rem 0' },
  hint:       { color: '#64748b', fontSize: '0.8rem', marginTop: '0.5rem', lineHeight: 1.5, background: '#f8fafc', padding: '0.6rem 0.75rem', borderRadius: 6, border: '1px solid #f1f5f9' },
  estadoBox:  { display: 'flex', alignItems: 'flex-start', gap: '0.75rem', padding: '0.75rem 1rem', borderRadius: 8 },
  estadoOk:   { background: '#dcfce7' },
  estadoFail: { background: '#fee2e2' },
  estadoIcon: { fontSize: '1.25rem', fontWeight: 800, lineHeight: 1.3 },
  estadoTexto:{ fontWeight: 700, color: '#1e293b' },
  btnSec:     { padding: '0.4rem 0.9rem', background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: 6, cursor: 'pointer', fontWeight: 600, fontSize: '0.85rem' },
  resumenRow: { display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginBottom: '0.75rem' },
  pill:       { fontSize: '0.72rem', fontWeight: 700, padding: '0.25rem 0.7rem', borderRadius: 12, textTransform: 'uppercase', letterSpacing: '0.03em' },
  pillSm:     { fontSize: '0.7rem', fontWeight: 700, padding: '0.15rem 0.55rem', borderRadius: 10 },
  filtros:    { display: 'flex', gap: '0.5rem', marginBottom: '0.75rem', flexWrap: 'wrap' },
  input:      { padding: '0.4rem 0.6rem', border: '1px solid #d1d5db', borderRadius: 6, fontSize: '0.85rem' },
  tabla:      { width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem' },
  th:         { padding: '0.5rem 0.65rem', textAlign: 'left', background: '#f8fafc', borderBottom: '1px solid #e2e8f0', fontWeight: 700, fontSize: '0.72rem', color: '#64748b', textTransform: 'uppercase', whiteSpace: 'nowrap' },
  tr:         { borderBottom: '1px solid #f1f5f9' },
  td:         { padding: '0.5rem 0.65rem', verticalAlign: 'middle' },
  code:       { fontFamily: 'monospace', fontSize: '0.78rem', background: '#f1f5f9', padding: '2px 6px', borderRadius: 4 },
  paginador:  { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '0.75rem' },
  salidaProceso: { marginTop: '0.75rem' },
  errorMsg:   { color: '#dc2626', fontSize: '0.875rem' },
  modalOverlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem', zIndex: 1000 },
  modalBox:    { background: 'white', borderRadius: 10, padding: '1.25rem', maxWidth: 950, width: '100%', maxHeight: '90vh', overflowY: 'auto' },
  modalHead:   { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1rem', marginBottom: '0.75rem' },
  modalSection: { marginTop: '0.75rem' },
  modalSubtitle: { margin: '0 0 0.4rem', fontSize: '0.85rem', fontWeight: 700, color: '#475569' },
  jsonBox:    { background: '#0f172a', color: '#e2e8f0', padding: '0.9rem 1rem', borderRadius: 8, fontSize: '0.78rem', fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace', maxHeight: 400, overflow: 'auto', whiteSpace: 'pre', lineHeight: 1.45 },
}
